module.exports = __webpack_public_path__ + "static/media/cogs.9c1585ea.svg";